import {
    EMPTY_APP, UPDATE_TITLE,
    OPEN_MODAL, CLOSE_MODAL,
    OPEN_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL,
    OPEN_PREVIEW_MODAL, CLOSE_PREVIEW_MODAL
} from './constants';

const initialState = {
    title: '',
    modal: '',
    modalConfirm: '',
    modalPreview: false
};

function appReducer(state = initialState, action) {
    switch(action.type) {
        case UPDATE_TITLE:
            return Object.assign({}, state, {
                title: action.data
            });
        case OPEN_MODAL:
            return Object.assign({}, state, {
                modal: action.data
            });
        case CLOSE_MODAL:
            return Object.assign({}, state, {
                modal: initialState.modal
            });
        case OPEN_CONFIRM_MODAL:
            return Object.assign({}, state, {
                modalConfirm: action.data
            });
        case CLOSE_CONFIRM_MODAL:
            return Object.assign({}, state, {
                modalConfirm: initialState.modalConfirm
            });
        case OPEN_PREVIEW_MODAL:
            return Object.assign({}, state, {
                modalPreview: true
            });
        case CLOSE_PREVIEW_MODAL:
            return Object.assign({}, state, {
                modalPreview: false
            });
        case EMPTY_APP:
            return initialState;
        default:
            return state;
    }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/store/reducers.js